// | ------------------------------------------------------------------------
// | Bootstrap - Tooltips
// | ------------------------------------------------------------------------ 

import '@popperjs/core'
import { Tooltip } from "bootstrap";

// | ------------------------------------------------------------------------ 


// Enable tooltips

document.addEventListener( 'DOMContentLoaded', function() {

  if(document.querySelectorAll('[data-bs-toggle="tooltip"]').length > 0){
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new Tooltip(tooltipTriggerEl)
    })
  } 

});